import React from "react";
import { View, StyleSheet, Link } from "@react-pdf/renderer";
import { PdfText } from "..";
import { getFontSize } from "../../utils/getFontSize";

const styles = StyleSheet.create({
  section: {
    width: "100%",
    paddingHorizontal: 10,
    marginBottom: 10,
  },
  projectInfoContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  projectName: {
    flexGrow: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  projectDuration: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 5,
  },
  title: {
    flexGrow: 1,
    marginRight: 5,
  },
  techList: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  list: {
    display: "flex",
    flexDirection: "column",
  },
  project: {
    fontWeight: 500,
    marginLeft: 5,
    fontSize: getFontSize(15),
  },
  dataBox: {},
  projectDataTitle: {
    fontWeight: 500,
    marginBottom: 5,
  },
  achievements: {
    marginBottom: 5,
  },
  achievementsItem: {
    marginBottom: 3,
  },
});

export const ProjectSection = ({
  projectName,
  productLink,
  projectRole,
  mainTech,
  period,
  duration,
  projectDescription,
  team,
  technologies,
  responsibilities,
  achievements,
  isProduct,
  isOneProject,
}) => {
  return (
    <View style={styles.section}>
      {isProduct ? (
        <View style={styles.dataBox}>
          <PdfText style={styles.projectDataTitle}>
            Role:{" "}
            <PdfText style={styles.description}>
              <PdfText>{projectRole} - </PdfText>
              <PdfText color="grey">{mainTech}</PdfText>
            </PdfText>
          </PdfText>
        </View>
      ) : (
        <View style={styles.projectInfoContainer}>
          <View style={styles.dataBox}>
            <PdfText style={styles.projectDataTitle}>
              Project:{" "}
              <Link src={productLink}>
                <PdfText style={styles.project}>{projectName}</PdfText>
              </Link>{" "}
              <PdfText> - {projectRole} - </PdfText>
              <PdfText color="grey">{mainTech}</PdfText>
            </PdfText>
          </View>

          {!isOneProject && (
            <View style={styles.projectDuration}>
              <PdfText>{period} - </PdfText>
              <PdfText color="grey">{duration}</PdfText>
            </View>
          )}
        </View>
      )}

      <View style={styles.dataBox}>
        <PdfText style={styles.projectDataTitle}>
          Description:{" "}
          <PdfText style={styles.description}>{projectDescription}</PdfText>
        </PdfText>
      </View>

      {team && (
        <View style={styles.dataBox}>
          <PdfText style={styles.projectDataTitle}>
            Team: <PdfText style={styles.description}>{team}</PdfText>
          </PdfText>
        </View>
      )}

      <View style={styles.dataBox}>
        <PdfText style={styles.projectDataTitle}>
          Technologies and methodologies:{" "}
          <View style={styles.row}>
            <View style={styles.techList}>
              {technologies.map((item, i) => {
                const notLast = i !== technologies.length - 1;
                return (
                  <View key={i}>
                    <PdfText color="grey" style={styles.info}>
                      {item}
                      {notLast && ", "}
                    </PdfText>
                  </View>
                );
              })}
            </View>
          </View>
        </PdfText>
      </View>

      {achievements && (
        <View style={styles.achievements}>
          <PdfText style={styles.projectDataTitle}>Achievements:</PdfText>

          <View>
            {achievements.map((item, i) => (
              <View key={i} style={styles.achievementsItem}>
                <PdfText style={styles.info}>&#8226; {item}</PdfText>
              </View>
            ))}
          </View>
        </View>
      )}

      <View style={styles.dataBox}>
        <PdfText style={styles.projectDataTitle}>Responsibilities:</PdfText>

        <View>
          {responsibilities.map((item, i) => (
            <View key={i} style={styles.responsibilitiesItem}>
              <PdfText style={styles.info}>&#8226; {item}</PdfText>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};
